
































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BagModelQuantityJustifyDialog extends BaseComponent {
  private modalOpen: boolean = true;

  @Prop()
  private item: any;

  private qtde = null;

  public form: any = {
    valid: false,
    rules: {
      justificativa: [(v) => (v && v.length > 0) || 'Informe a justificativa'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted(){
    this.qtde = this.item.quantidade;
    setTimeout(() => {
      this.$refs['justificativa'].focus();
    }, 200);

  }

  getMsgMinMaxBolsaMulticompart() {
    return (
      `Este cliente está configurado para prescrever entre <strong>${this.item.unidade.minBolsaMulticompart} e ${this.item.unidade.maxBolsaMulticompart}</strong>` +
      ` unidade(s) de bolsa(s) multicompartimentada(s).`
    );
  }

  getPrescriptionLabel(qtde) {
    if (qtde == 1) {
      return '1 unidade';
    }
    return `${qtde} unidades`;
  }

  public cancel(): void {
    this.$emit('cancel');
  }

  public confirm(): void {
    this.$emit('confirm', this.qtde);
  }
}
